import { Alert, Box, Button, CircularProgress, Typography } from "@mui/material";
import { errorMessage } from "../services/api";

export function LoadingBlock({ label = "Loading…" }) {
  return (
    <Box sx={{ py: 10, display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
      <CircularProgress size={34} thickness={4} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  );
}

export function ErrorNote({ error, onRetry }) {
  return (
    <Alert
      severity="error"
      sx={{ borderRadius: 3 }}
      action={
        onRetry ? (
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        ) : null
      }
    >
      {errorMessage(error)}
    </Alert>
  );
}

/** Shows loading / error / the page content, in that order. */
export function DataState({ state, children }) {
  if (state.loading && !state.data) return <LoadingBlock />;
  if (state.error) return <ErrorNote error={state.error} onRetry={state.reload} />;
  if (!state.data) return null;
  return children(state.data);
}
